/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { rolesControllerCreate } from "./rolesControllerCreate";
import { rolesControllerFindAll } from "./rolesControllerFindAll";
import { rolesControllerFindOne } from "./rolesControllerFindOne";
import { rolesControllerRemove } from "./rolesControllerRemove";
import { rolesControllerUpdate } from "./rolesControllerUpdate";

export function rolesService() {
  return { rolesControllerFindAll, rolesControllerCreate, rolesControllerFindOne, rolesControllerUpdate, rolesControllerRemove }
}